import { render, staticRenderFns } from "./extraEdit.vue?vue&type=template&id=880ce366"
import script from "./extraEdit.vue?vue&type=script&lang=js"
export * from "./extraEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports